export const STUDIO_BREAKPOINT_LARGE_DESKTOP = "large-desktop";
export const STUDIO_BREAKPOINT_DESKTOP = "desktop";
export const STUDIO_BREAKPOINT_PHONE = "phone";

export const STUDIO_BREAKPOINTS = Object.freeze([
  Object.freeze({ key: STUDIO_BREAKPOINT_LARGE_DESKTOP, minWidth: 1440 }),
  Object.freeze({ key: STUDIO_BREAKPOINT_DESKTOP, minWidth: 768 }),
  Object.freeze({ key: STUDIO_BREAKPOINT_PHONE, minWidth: 0 }),
]);

export const STICKY_BREAKPOINTS = Object.freeze([STUDIO_BREAKPOINT_LARGE_DESKTOP, STUDIO_BREAKPOINT_DESKTOP]);

export function isStudioBreakpoint(key) {
  return STUDIO_BREAKPOINTS.some(breakpoint => breakpoint.key === key);
}

export function studioBreakpointFor(width) {
  if (!Number.isFinite(width) || width < 0) {
    throw new Error(`studioBreakpointFor needs a viewport width of 0 or more and got ${width}.`);
  }
  return STUDIO_BREAKPOINTS.find(breakpoint => breakpoint.minWidth <= width).key;
}

export function studioBreakpointMediaQuery(key) {
  const index = STUDIO_BREAKPOINTS.findIndex(breakpoint => breakpoint.key === key);
  if (index === -1) {
    throw new Error(`"${key}" is not a Studio breakpoint. Known: ${STUDIO_BREAKPOINTS.map(breakpoint => breakpoint.key).join(", ")}.`);
  }
  const { minWidth } = STUDIO_BREAKPOINTS[index];
  const wider = STUDIO_BREAKPOINTS[index - 1];
  const parts = [];
  if (minWidth > 0) {
    parts.push(`(min-width: ${minWidth}px)`);
  }
  if (wider) {
    parts.push(`(max-width: ${wider.minWidth - 1}px)`);
  }
  return parts.join(" and ");
}

export function stickySlotFor(breakpoint) {
  if (!isStudioBreakpoint(breakpoint)) {
    throw new Error(`"${breakpoint}" is not a Studio breakpoint, so it has no sidebar preferences.`);
  }
  return breakpoint === STUDIO_BREAKPOINT_PHONE ? STUDIO_BREAKPOINT_DESKTOP : breakpoint;
}
